import React, { useEffect } from 'react'
import { PinSvg } from '../../../../assets/icons/svgComponents'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import Button from '../../../button'
import Input from '../../../input'
import SelectInput from '../../../select-input'
import Textarea from '../../../textarea'
import {
  FormStyled,
  LabelRadio,
  NumberRow,
  RadioOption,
  Row,
  RowRadio,
  StyledRadio,
  Tips,
  TitleRow
} from './style'
import { useForm } from '../../../../hooks'
import { SessionModel } from '../../../../../domain/models/session'
import { useAlert } from 'react-alert'
import {
  createNewSession,
  updateSession
} from '../../../../../main/usecases/services/session'
import moment from 'moment'

type FormProps = {
  session?: SessionModel | undefined
  cdServiceProps: number | undefined
}

export const PaymetMethods = [
  {
    value: 1,
    label: 'Cartão de crédito'
  },
  {
    value: 2,
    label: 'Cartão de débito'
  },
  {
    value: 3,
    label: 'Transferência'
  },
  {
    value: 4,
    label: 'Boleto'
  },
  {
    value: 5,
    label: 'Dinheiro'
  },
  {
    value: 6,
    label: 'Pix'
  }
]

const SessionForm = ({ session, cdServiceProps }: FormProps) => {
  const alert = useAlert()
  const { refresh, setRefresh } = useOnChangeDetect()
  const { modalClose } = useModalBox()
  const dateInput = useForm()
  const hourStartInput = useForm()
  const hourFinalInput = useForm()
  const titleInput = useForm()
  const resumeInput = useForm()
  const valueInput = useForm()
  const paymentMethodInput = useForm()
  const statusInput = useForm()

  useEffect(() => {
    dateInput.setValue(moment().format('yyyy-MM-DD'))
    hourStartInput.setValue(moment().format('HH:mm'))
    hourFinalInput.setValue(moment().format('HH:mm'))
    if (session) {
      dateInput.setValue(moment(session.dataInicio).format('yyyy-MM-DD'))
      hourStartInput.setValue(
        moment(session.dataInicio?.replace('.000+00:00', '')).format('HH:mm')
      )
      hourFinalInput.setValue(
        moment(session.dataFim?.replace('.000+00:00', '')).format('HH:mm')
      )
      resumeInput.setValue(session.resumo)
      valueInput.setValue(session.valor)
      paymentMethodInput.setValue(!session.formaPgto ? null : session.formaPgto)
      statusInput.setValue(convertStatusReverse(session?.pago))
      titleInput.setValue(session.titulo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session, refresh])

  const convertStatus = (val: string) => {
    switch (val) {
      case 'true':
        return true
      case 'false':
        return false

      default:
        return null
    }
  }
  const convertStatusReverse = (val: boolean | undefined | null) => {
    switch (val) {
      case true:
        return 'true'
      case false:
        return 'false'

      default:
        return null
    }
  }

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (cdServiceProps) {
      try {
        const body: SessionModel = {
          cdSessao: null,
          data: moment(dateInput.value).format('DD/MM/YYYY'),
          formaPgto: Number(paymentMethodInput.value),
          horaFim: hourFinalInput.value,
          horaInicio: hourStartInput.value,
          pago: convertStatus(statusInput.value),
          resumo: resumeInput?.value,

          servico: {
            cdServico: cdServiceProps
          },
          titulo: titleInput.value,
          valor: Number(valueInput.value)
        }
        if (session?.cdSessao) {
          console.log(body)
          await updateSession().update({
            ...session,
            ...body,
            cdSessao: session.cdSessao
          })
          modalClose()
          alert.show('Sessão atualizada com sucesso', {
            type: 'success',
            timeout: 4000
          })
        } else {
          await createNewSession().post(body)
          modalClose()
          alert.show('Sessão criada com sucesso', {
            type: 'success',
            timeout: 4000
          })
        }
        setRefresh((prev: any) => !prev)
      } catch (error) {
        alert.show('Erro ao criar um sessão', {
          type: 'error',
          timeout: 4000
        })
      }
    }
  }

  return (
    <FormStyled className="validate-report-modal" onSubmit={onSubmit}>
      <div className="content">
        <TitleRow>
          <NumberRow>1</NumberRow>Dados Gerais
        </TitleRow>

        <Row className="d-flex">
          <Input
            labelColor="#4F4F4F"
            label="Data*"
            name="county"
            type="date"
            style={{ width: '95%' }}
            required
            {...dateInput}
          />
          <Input
            labelColor="#4F4F4F"
            label="Hora de início*"
            name="horaInicio"
            type="time"
            style={{ width: '95%' }}
            required
            {...hourStartInput}
          />
          <Input
            labelColor="#4F4F4F"
            label="Hora Fim*"
            name="horaFim"
            type="time"
            style={{ width: '95%' }}
            required
            {...hourFinalInput}
          />
        </Row>
        <TitleRow>
          <NumberRow>2</NumberRow>Sessão
        </TitleRow>

        <Row className="d-flex">
          <Input
            labelColor="#4F4F4F"
            label="Título*"
            name="title"
            type="title"
            required
            {...titleInput}
          />
        </Row>
        <Row className="d-flex">
          <Textarea
            label="Resumo da sessão"
            labelColor="#4F4F4F"
            name="resume"
            {...resumeInput}
          />
        </Row>
        <TitleRow>
          <NumberRow>3</NumberRow>Pagamento
        </TitleRow>

        <RowRadio className="d-flex">
          <Input
            labelColor="#4F4F4F"
            label="Valor"
            name="value"
            type="number"
            // required
            {...valueInput}
          />
          <SelectInput
            labelColor="#4F4F4F"
            label="Forma de pagamento"
            name="value"
            options={PaymetMethods}
            // required
            {...paymentMethodInput}
          />
          <StyledRadio>
            <span>Status</span>
            <LabelRadio>
              <RadioOption
                name="status"
                type="radio"
                {...statusInput}
                value={'true'}
                checked={statusInput.value === 'true'}
              />
              Pago
            </LabelRadio>
            <LabelRadio>
              <RadioOption
                name="status"
                type="radio"
                {...statusInput}
                value={'false'}
                checked={statusInput.value === 'false'}
              />
              Não pago
            </LabelRadio>
          </StyledRadio>
        </RowRadio>
        <Tips>
          <PinSvg></PinSvg>
          <p className="tips">
            <b>Dica: </b> Registrar os pagamentos das sessões irá te auxiliar na
            sua organização financeira
          </p>
        </Tips>
      </div>
      <Row className="button-container">
        <label className="required-msg">*Campos obrigatórios</label>
        <div className="buttons">
          <button
            className="access-complete-register-button"
            onClick={() => modalClose(true)}
          >
            Cancelar
          </button>
          <Button>{session ? 'Atualizar' : 'Criar'}</Button>
        </div>
      </Row>
    </FormStyled>
  )
}

export default SessionForm
